// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "Login_Home_Welcome" + "." + "f090b0d4" + ".css";
};